export default __webpack_public_path__ + "static/media/checked.303c2a94.svg";